import Model from 'flarum/common/Model';
export default class DataType extends Model {
  type() {
    return Model.attribute('type').call(this);
  }
  exportDescription() {
    return Model.attribute('exportDescription').call(this);
  }
  anonymizeDescription() {
    return Model.attribute('anonymizeDescription').call(this);
  }
  deleteDescription() {
    return Model.attribute('deleteDescription').call(this);
  }
  extension() {
    return Model.attribute('extension').call(this);
  }
}
flarum.reg.add('flarum-gdpr', 'admin/models/DataType', DataType);